export default {
  name: 'Desktop',
  components: {
    'vue-city': require('./City/index.vue').default,
    'vue-labels': require('./Labels/index.vue').default,
    'vue-regions': require('./Regions/index.vue').default,
    'vue-radius': require('../Radius/index.vue').default,
  },
};
